var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailnotlinked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 102,
    viewBox: "0 0 119 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.7938 68.6301H33.8782V84.8151H70.7938V68.6301Z",
    fill: "#E4E4E5",
    stroke: "#868995"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 69.0144L8.4298 47.5121C9.16745 45.3773 10.6593 43.5869 12.6239 42.4788L18.8179 38.985L13.1876 69.0144H1Z",
    fill: "#E4E4E5",
    stroke: "#868995"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.724 69.0144L93.2946 47.5121C92.5569 45.3773 91.065 43.5869 89.1005 42.4788L82.9065 38.985L88.5367 69.0144H100.724Z",
    fill: "#E4E4E5",
    stroke: "#868995"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8266 1H74.342L86.7474 13.6355C84.2859 36.8062 87.1122 55.931 95.2263 71.01C91.0199 71.01 81.7842 71.01 67.5192 71.01H34.9754C20.9674 71.01 11.1804 71.01 5.61426 71.01C12.5457 60.8643 14.8994 37.937 12.6753 2.2281L12.6753 2.2281C12.6356 1.59086 13.1189 1.04202 13.7548 1.00225C13.7787 1.00075 13.8027 1 13.8266 1Z",
    fill: "white",
    stroke: "#868995"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9155 16.3176V25.8552C37.9155 27.2918 39.0776 28.4563 40.5112 28.4563H56.0849C57.5185 28.4563 58.6806 27.2918 58.6806 25.8552V16.3176C58.6806 14.881 57.5185 13.7164 56.0849 13.7164H40.5112C39.0776 13.7164 37.9155 14.881 37.9155 16.3176ZM54.692 19.7164L48.6355 22.3176C48.4173 22.4116 48.1702 22.4116 47.952 22.3176L41.8955 19.7164C41.4559 19.5273 41.2525 19.0168 41.4413 18.5763C41.63 18.1357 42.1394 17.9319 42.579 18.1211L47.952 20.4274C48.1702 20.5214 48.4173 20.5214 48.6355 20.4274L54.0084 18.1211C54.4481 17.9319 54.9574 18.1357 55.1462 18.5763C55.335 19.0168 55.1316 19.5273 54.692 19.7164Z",
    fill: "#868995"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5332 56.8525H73.6778",
    stroke: "#F2F2F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5332 45.7257H44.8374",
    stroke: "#F2F2F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3735 45.7252H73.6777",
    stroke: "#F2F2F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 69.2087H33.67C34.3071 69.2087 34.8236 69.7263 34.8236 70.3648V75.8839C34.8236 77.7993 36.3731 79.3521 38.2845 79.3521H61.8948C63.8062 79.3521 65.3557 77.7993 65.3557 75.8839V70.3648C65.3557 69.7263 65.8721 69.2087 66.5093 69.2087H101L89.3584 97.9754C88.6523 99.7202 86.9611 100.862 85.0823 100.862H15.5245C13.5739 100.862 11.8341 99.6327 11.1785 97.7917L1 69.2087Z",
    fill: "white",
    stroke: "#868995"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34497 101H91.5588",
    stroke: "#868995",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2544 1.57861V13.1393",
    stroke: "#868995",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2544 13.1394H85.7905",
    stroke: "#868995",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1117 13.7164C85.2701 26.6573 85.4185 37.071 86.5568 44.9577C87.6951 52.8443 89.9046 60.7087 93.1853 68.5507H89.9258C86.7879 62.4142 84.6328 55.6383 83.4607 48.2232C82.2885 40.8082 81.9741 29.3059 82.5174 13.7164H86.1117Z",
    fill: "#F2F2F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0317 75.5664H65.0257",
    stroke: "#868995",
    strokeLinecap: "square"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9853 69.6642C34.3597 71.7715 33.9853 74.8659 34.3597 76.6905C34.8757 77.9099 35.4435 78.76 36.0633 79.2408L34.7729 79.3171C32.8649 79.4298 31.2269 77.9711 31.1144 76.059C31.1104 75.991 31.1084 75.923 31.1084 75.8549V69.6642C31.9479 69.6642 32.9069 69.6642 33.9853 69.6642Z",
    fill: "#F2F2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0733 69.9039H100.202L88.7117 98.3333C88.1825 99.6427 86.9137 100.5 85.504 100.5H81.686L93.0733 69.9039Z",
    fill: "#E4E4E5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9999 50C81.7451 50 71 60.7451 71 74.0001C71 87.2547 81.7451 98 94.9999 98C108.255 98 119 87.2547 119 74.0001C119 60.7451 108.255 50 94.9999 50Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9999 55C84.5066 55 76 63.5066 76 74C76 84.4933 84.5066 93 94.9999 93C105.493 93 114 84.4933 114 74C114 63.5066 105.493 55 94.9999 55Z",
    fill: "white",
    stroke: "#868995"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2913 79.2438L90.9346 81.6005C89.9576 82.5775 88.3754 82.5775 87.3992 81.6007C86.4228 80.6243 86.4228 79.0419 87.399 78.0657L92.1131 73.3516C93.0893 72.3753 94.6717 72.3753 95.6479 73.3516C95.9733 73.677 96.501 73.677 96.8264 73.3516C97.1518 73.0262 97.1518 72.4985 96.8264 72.1731C95.1993 70.546 92.5617 70.546 90.9346 72.1731L86.2206 76.8872C84.5935 78.5143 84.5935 81.1519 86.2206 82.779C87.8475 84.4069 90.4852 84.4069 92.1132 82.779L94.4698 80.4223C94.7953 80.0969 94.7953 79.5692 94.4698 79.2438C94.1444 78.9184 93.6167 78.9184 93.2913 79.2438Z",
    fill: "#868995"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M103.779 71.1123C105.406 69.4852 105.406 66.8476 103.779 65.2206C102.152 63.5935 99.5148 63.5935 97.8868 65.2204L95.0592 68.048C94.7338 68.3735 94.7338 68.9011 95.0592 69.2265C95.3846 69.552 95.9123 69.552 96.2377 69.2265L99.0651 66.3991C100.042 65.4228 101.625 65.4228 102.601 66.3991C103.577 67.3753 103.577 68.9576 102.601 69.9338L97.4158 75.1188C96.4396 76.095 94.8573 76.095 93.8811 75.1188C93.5556 74.7933 93.028 74.7933 92.7026 75.1188C92.3771 75.4442 92.3771 75.9718 92.7026 76.2973C94.3297 77.9244 96.9672 77.9244 98.5943 76.2973L103.779 71.1123Z",
    fill: "#868995"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.59 78.4109C100.264 78.0855 99.7365 78.0855 99.4111 78.4109C99.0856 78.7364 99.0856 79.264 99.4111 79.5894L101.91 82.0886C102.236 82.414 102.763 82.414 103.089 82.0886C103.414 81.7632 103.414 81.2355 103.089 80.9101L100.59 78.4109Z",
    fill: "#868995"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4117 69.5902C89.7372 69.9157 90.2648 69.9157 90.5902 69.5902C90.9157 69.2648 90.9157 68.7372 90.5902 68.4117L88.0886 65.9101C87.7632 65.5847 87.2355 65.5847 86.9101 65.9101C86.5847 66.2355 86.5847 66.7632 86.9101 67.0886L89.4117 69.5902Z",
    fill: "#868995"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M104.167 76.4999H101.667C101.206 76.4999 100.833 76.873 100.833 77.3332C100.833 77.7934 101.206 78.1665 101.667 78.1665H104.167C104.627 78.1665 105 77.7934 105 77.3332C105 76.873 104.627 76.4999 104.167 76.4999Z",
    fill: "#868995"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6666 68.1666C92.1268 68.1666 92.4999 67.7935 92.4999 67.3333V64.8333C92.4999 64.3731 92.1268 64 91.6666 64C91.2063 64 90.8333 64.3731 90.8333 64.8333V67.3333C90.8332 67.7935 91.2063 68.1666 91.6666 68.1666Z",
    fill: "#868995"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8333 71.4999H88.3333C88.7935 71.4999 89.1666 71.1268 89.1666 70.6666C89.1666 70.2063 88.7935 69.8333 88.3333 69.8333H85.8333C85.3731 69.8333 85 70.2063 85 70.6666C85 71.1268 85.3731 71.4999 85.8333 71.4999Z",
    fill: "#868995"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3331 79.8331C97.8728 79.8331 97.4998 80.2062 97.4998 80.6664V83.1664C97.4998 83.6266 97.8728 83.9997 98.3331 83.9997C98.7933 83.9997 99.1664 83.6266 99.1664 83.1664V80.6664C99.1664 80.2062 98.7933 79.8331 98.3331 79.8331Z",
    fill: "#868995"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailnotlinked);
export default __webpack_public_path__ + "static/media/emailnotlinked.67fd970e.svg";
export { ForwardRef as ReactComponent };